import React from "react";
import { buildProbeTable, formatPrice } from "./importAdapters";

/**
 * Цены на контрольных весах сразу после заливки.
 *
 * Веса, не совпадающие с точками тарифной лестницы, помечены: расчёт внутри
 * весового диапазона идёт по другой ветке, чем расчёт ровно на границе, и
 * проверка по одним лишь круглым весам этого не покрывает.
 */
const ProbeTable = ({ probe }) => {
  const { weights, rows } = React.useMemo(() => buildProbeTable(probe), [probe]);

  if (!rows.length) {
    return <p style={{ color: "#6b7280" }}>Контрольные точки не рассчитаны.</p>;
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ borderCollapse: "collapse", width: "100%", fontSize: "0.9rem" }}>
        <caption style={{ captionSide: "bottom", textAlign: "left", padding: "8px 0", color: "#6b7280" }}>
          Веса со звёздочкой не совпадают с точками тарифной лестницы — именно на них
          видны ошибки расчёта внутри весового диапазона.
        </caption>
        <thead>
          <tr>
            <th style={headCell}>Миля</th>
            <th style={headCell}>Маршрут</th>
            {weights.map(({ weight, onLadder }) => (
              <th key={weight} style={{ ...headCell, textAlign: "right" }}>
                {Number(weight).toLocaleString("ru-RU")}
                {onLadder ? "" : " *"}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.legId}>
              <td style={cell}>{row.mileType}</td>
              <td style={cell}>{row.route}</td>
              {row.prices.map(({ weight, price }) => {
                const dropped = row.dropped.has(String(weight));
                return (
                  <td
                    key={weight}
                    title={dropped ? "Цена ниже, чем на меньшем весе" : undefined}
                    style={{
                      ...cell,
                      textAlign: "right",
                      fontVariantNumeric: "tabular-nums",
                      color: dropped ? "#b91c1c" : undefined,
                      fontWeight: dropped ? 600 : undefined,
                    }}
                  >
                    {formatPrice(price)}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const headCell = {
  textAlign: "left",
  padding: "6px 10px",
  borderBottom: "1px solid #d1d5db",
  whiteSpace: "nowrap",
  fontSize: "0.75rem",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  color: "#6b7280",
};

const cell = {
  padding: "6px 10px",
  borderBottom: "1px solid #f1f5f9",
  whiteSpace: "nowrap",
};

export default ProbeTable;
